import "./services.css"
import Service from "../service/Service"
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();
  return (
    <div className="services-container">
        <h3>{t("services.title")}</h3>

        <div className="services-wrapper">
            <Service />
        </div>
    </div>
  )
}

export default Services